module.exports = __webpack_public_path__ + "img/arrow-right-white.596c50d9.svg";